import { z } from 'zod'

import type { NoContext } from '~/services/api/contracts/NoContext'
import {
  StoreReviewStoreReviewsQuerySchema,
  StoreReviewSortSchema,
  StoreReviewStatusSchema
} from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

// DashboardStoreReviewIndexRequest::prepareForValidation
const normalize = fieldNormalizer({
  enums: [
    { field: 'status', options: StoreReviewStatusSchema.options },
    { field: 'sort', options: StoreReviewSortSchema.options }
  ]
})

export const StoreReviewStoreReviews = (_context: NoContext = {}) =>
  z.preprocess(normalize, StoreReviewStoreReviewsQuerySchema)
